import { useTranslation } from 'react-i18next';

import { FilledButton } from 'libs/ui';
import { ModeInput } from './mode-input';
import { TimeSelect } from './time-select';
import { WeekInput } from './week-input';

export const ScheduleRow = (props) => {
  const { id, row, onChange, onDel } = props;
  const { t } = useTranslation();

  const change2 = (name, val) => {
    // console.log('🚀 ~ change2', name, val);
    onChange(id, name, val);
  };

  const del = () => {
    onDel(id);
  };

  return (
    <tr>
      <td>
        <ModeInput name="mode" value={row.mode} onChange={change2} />
      </td>
      <td>
        <TimeSelect name="time_at" value={row.time_at} onChange={change2} />
      </td>
      <WeekInput name="weekdays" value={row.weekdays} onChange={change2} />
      <td>
        <FilledButton color="danger" className="size-sm" onClick={del}>{t('buttons.Удалить')}</FilledButton>
      </td>
    </tr>
  );
};
